export default {
  logout: "Log out",
  Name: "Name",
  Quantity: "Quantity",
  BatchsPage: "Batchs Page",
  CameraPage: "Camera Page",
  "Not Found": "Not Found",
  Verification: "Verification",
  "Verification passed": "Verification passed",
  "Verification not passed": "Verification not passed",
  Organization: "Organization",
  "Product group": "Product group",
  "Product name": "Product name",
  Region: "Region",
  Series: "Series",
  Status: "Status",
  Volume: "Volume",
  stampProducedDate: "Stamp produced date",
  stampReceivedDate: "Stamp received date",
  EmployeePage: "Employee page",
  "Create employee": "Create employee",
  "Delete employee": "Delete employee",
  Surname: "Surname",
  Address: "Address",
  Enter: "Enter",
  Login: "Login",
  Password: "Password",
  Submit: "Submit",
  "Choose products": "Choose products",
  "Choose quantity": "Choose quantity",
  "Next step": "Next step",
  "Make an order": "Make an order",
  "Order is maked": "Order is maked",
  MarksPage: "Marks page",
  Available: "Available",
  Date: "Date",
  "Order ID": "Order ID",
  "Product code": "Product code",
  "Package code": "Package code",
  code: "code",
  notFoundPage: "Page not found",
  "Profile page": "Profile page",
  "Company information": "Company information",
  "Company BIN": "Company BIN",
  "Company name": "Company name",
  "Post code": "Post code",
  Contacts: "Contacts",
  "Profile information": "Profile information",
  "Mobile phone": "Mobile phone",
  Email: "Email",
  ReportsPage: "Reports page",
  ReviewPage: "Review page",
  UKMPage: "UKM page",
  Number: "Number",
  Profile: "Profile",
  Reports: "Reports",
  Employee: "Employee",
  Reviews: "Reviews",
  Batchs: "Batchs",
  Marks: "Marks",
  Camera: "Camera",
  UKM: "UKM",
  Orders: "Orders",
  OrdersPage: "Orders page",
  Aggregations: "Aggregations",
  AggregationsPage: "Aggregations page",
  Director: "Director",
  "Name Surname": "Name Surname",
  Checked: "Checked",
  Generated: "Generated",
  "Mark ID": "Mark ID",
  Logout: "Log out",
  Code: "Code",
  Markings: "Markings",
  Marking: "Marking",
  "Enter manually": "Enter manually",
  "Use camera": "Use camera",
  Find: "Find",
  Yes: "Yes",
  No: "No",
  Refresh: "Refresh",
  january: "january",
  february: "february",
  march: "march",
  april: "april",
  may: "may",
  june: "june",
  july: "july",
  august: "august",
  september: "september",
  october: "october",
  november: "november",
  december: "december",
  in: "in",
  "Unused marks": "Unused marks",
  "New order": "New order",
  fio: "Name Surname Middlename",
  "Confirm password": "Confirm password",
  GROUP: "group",
  UNIT: "unit",
  OPERATOR: "operator",
  SELF_MADE: "self made",
  "Enter by IIN": "Enter by IIN",
  "Enter by ECP": "Enter by ECP",
  "Don't have an account yet ?": "Don't have an account yet ?",
  "Register now": "Register now",
  "Select certificate": "Select certificate",
  "Error connecting to interlayer": "Error connecting to interlayer",
  "Make sure the program is running and try again.":
    "Make sure the program is running and try again.",
  "Instructions for starting the program":
    "Instructions for starting the program",
  "Select document type": "Select document type",
  Cancel: "Cancel",
  "Enter the password for the certificate":
    "Enter the password for the certificate",
  "Incorrect password": "Incorrect password",
  "Enter password": "Enter password",
  "Attempts left": "Attempts left",
  "EDS for the identity card is blocked. Contact NAO GK `Government for citizens`":
    "EDS for the identity card is blocked. Contact NAO GK `Government for citizens`",
  "Select the certificate for authorization (with the AUTH prefix) and re-enter the password":
    "Select the certificate for authorization (with the AUTH prefix) and re-enter the password",
  "Select the certificate to sign the application and re-enter the password":
    "Select the certificate to sign the application and re-enter the password",
  "A technical error has occurred. Please try again later.":
    "A technical error has occurred. Please try again later.",
  "Select key": "Select key",
  Choose: "Choose",
  "Certificate data": "Certificate data",
  IIN: "IIN",
  BIN: "BIN",
  "Name of company": "Name of company",
  Validity: "Validity",
  "Choose another certificate": "Choose another certificate",
  Step: "Step",
  "Information of company": "Information of company",
  "IIN/BIN of organization": "IIN/BIN of organization",
  "Legal verification": "Legal verification",
  'According to the Law of the Republic of Kazakhstan dated March 29, 2016 "On Amendments and Additions to Certain Legislative Acts of the Republic of Kazakhstan on the Issues of Reducing Permitting Documents and Simplifying Permitting Procedures", registration as an individual entrepreneur is carried out on the electronic licensing portal':
    'According to the Law of the Republic of Kazakhstan dated March 29, 2016 "On Amendments and Additions to Certain Legislative Acts of the Republic of Kazakhstan on the Issues of Reducing Permitting Documents and Simplifying Permitting Procedures", registration as an individual entrepreneur is carried out on the electronic licensing portal',
  "Legal address": "Legal address",
  "I agree to the processing of personal data":
    "I agree to the processing of personal data",
  "Back to": "Back to",
  ECP: "ECP",
  "Become an entrepreneur": "Become an entrepreneur",
  "Personal data": "Personal data",
  phoneNumber: "Phone number",
  Complete: "Complete",
  ismpt: "IS MPT",
  Token: "Token",
  SUZ: "SUZ",
  connected: "connected",
  "not connected": "not connected",
  Edit: "Edit",
  Connect: "Connect",
  "Edit employee": "Edit employee",
  Lines: "Lines",
  Attached: "Attached",
  "Cancel delete": "Cancel delete",
  Attach: "Attach",
  Terminals: "Terminals",
  Products: "Products",
  productName: "Product name",
  amountBox: "Amount box",
  amountPalette: "Amount palette",
  createProduct: "Create product",
  Create: "Create",
  productId: "Product ID",
  productGtin: "Product GTIN",
  Barcode: "Barcode",
  Save: "Save",
  productInformation: "Product information",
  Order: "Order",
  "Date of creation": "Date of creation",
  "Execution time (milliseconds)": "Execution time (milliseconds)",
  "Product order ID": "Product order ID",
  "Contact name": "Contact name",
  "Preparation method": "Preparation method",
  "Codes total": "Codes total",
  "Codes received": "Codes received",
  "Get marking codes": "Get marking codes",
  "Close suborder": "Close suborder",
  Add: "Add",
  "Search by name": "Search by name",
  Device: "Device",
  "Change production line": "Change production line",
  "Add production line": "Add production line",
  Devices: "Devices",
  Line: "Line",
  "New device": "New device",
  "Editing device": "Editing device",
  "Welcome to the Marking system": "Welcome to the Marking system",
  "Follow these steps to get started": "Follow these steps to get started",
  "Make your product page available in real time":
    "Make your product page available in real time",
  "Add your first product": "Add your first product",
  "Create an account": "Create an account.",
  "You've already done it! It remains to complete the initial setup":
    "You've already done it! It remains to complete the initial setup.",
  "Add your first SKU": "Add your first SKU",
  "Store all product information in one place.":
    "Store all product information in one place",
  "Download the Android app.": "Download the Android app.",
  "Prepare your products for loading into the system":
    "Prepare your products for loading into the system.",
  "Print or request 'Marking' codes": "Print or request 'Marking' codes.",
  "To start using the system right away please use your printer to print test codes Soon we will provide the ability to do this remotely":
    "To start using the system right away, please use your printer to print test codes. Soon we will provide the ability to do this remotely.",
  dt: "Date",
  qty: "Quantity",
  id: "ID",
  status: "Status",
  available: "Available",
  barcode: "Barcode",
  "Export to excel": "Export to excel",
  PRODUCTION: "Production",
  IMPORT: "Import",
  REMAINS: "Remains",
  CROSSBORDER: "Crossborder",
  "New document": "New document",
  Receiver: "Receiver",
  Sender: "Sender",
  Documents: "Documents",
  DocumentsPage: "Documents page",
  "Create document": "Create document",
  Invoice: "Invoice",
  Invoices: "Invoices",
  "Create invoice": "Create invoice",
  "New invoice": "New invoice",
  "Add product": "Add product",
  "BIN of Receiver": "BIN of Receiver",
  signWithEcp: "Sign with ECP",
  Outbox: "Outbox",
  Inbox: "Inbox",
  addingProduct: "Adding product",
  Product: "Product",
  "Method of forming serial goods": "Method of forming serial goods",
  "Method of release of goods into circulation":
    "Method of release of goods into circulation",
  "Product type": "Product type",
  "Alcohol (unit)": "Alcohol (unit)",
  "Alcohol (group packaging)": "Alcohol (group packaging)",
  Medicines: "Medicines",
  "Cigarettes (block)": "Cigarettes (block)",
  "Cigarettes (package)": "Cigarettes (package)",
  Shoes: "Shoes",
}
